import CartCommodityInterface from '@/interfaces/CartCommodityInterface';
import Product from '@/classes/Product';

class CartItem {
  public key: string;

  attributes: CartCommodityInterface;

  constructor(key: string, attributes: CartCommodityInterface) {
    this.key = key;
    this.attributes = attributes;
  }

  get product(): Product {
    return this.attributes.product;
  }

  get params(): Record<string, any> {
    return this.attributes.params as unknown as Record<string, any>;
  }
}

export default CartItem;
